<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Décrire une mare</p>
</div>

<div id="map"></div>

<div class="py-2 px-3 bt">
	<p class="mb-0 text-center text-secondary small js-map-hint">Sélectionnez la mare que vous souhaitez décrire sur la carte</p>
</div>
<div class="py-2 px-3 bt d-flex justify-content-between align-items-center">
	<div class="small">La mare n'est pas affichée ?</div>
	<a href="#pond/locate" class="btn btn-green">Ajoutez-là</a>
</div>
